/**
 * @description
 * OfflineBannerComponent displays a server-offline warning banner.
 * Drop `<app-offline-banner></app-offline-banner>` into any template —
 * it handles the ServerStatusService injection internally.
 *
 * Dependencies:
 * - ServerStatusService (detects server connectivity via HTTP interceptor heartbeat)
 */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { AsyncPipe, NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

import { ServerStatusService } from '@app/common/server-status.service';

@Component({
  selector: 'app-offline-banner',
  templateUrl: './offline-banner.component.html',
  styleUrls: ['./offline-banner.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, NgClass, MatIconModule],
})
export class OfflineBannerComponent {
  /**
   * Optional manual visibility override.
   * When undefined, defaults to automatic offline monitoring: (serverStatusService.isOnline$ === false).
   */
  @Input() show?: boolean | null = undefined;

  /** Visual style / severity of the banner: 'error' (default), 'warning' (orange), or 'info' (blue). */
  @Input() type: 'error' | 'warning' | 'info' = 'error';

  /** Material icon name to display. Defaults to 'cloud_off' for offline. */
  @Input() icon: string = 'cloud_off';

  /** Message to display in the banner. */
  @Input() message: string = 'Impossible de se connecter au serveur (Serveur inaccessible).';

  /** If true, displays a compact horizontal banner suited for embedding at the top of a page. */
  @Input() compact: boolean = false;

  constructor(public serverStatusService: ServerStatusService) {}
}
